import styles from "./style.module.css";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useEffect, useState } from "react";
import AdminApi from "../../../config/apis/admin";
import { api } from "../../../config/apis";
import { DataLoader } from "../../../helper/helperFunction";
import SelectOptionsApi from "../../../components/SelectApi";
import FilterMultiSelect from "./FilterMultiSelect";
import moment from "moment";

export const Enrollments = (params) => {
  const [filters, setFilters] = useState();
  const [activeButton, setActiveButton] = useState("soFar");

  const handleUpdate = (name, value) => {
    setFilters((prevState) => {
      const updatedFilters = {
        ...prevState,
        [name]: value,
      };
      if (name === "year" || name === "month") {
        delete updatedFilters.from_date;
        delete updatedFilters.to_date;
      }
      if (name === "year") {
        if (!value || value.length === 0) {
          delete updatedFilters.month;
        }
      }
      return updatedFilters;
    });
    setActiveButton("");
  };
  const filterActive =
    params.filterData.phase_id || params.filterData.cohort_id;
  const [enrollData, setEnrollData] = useState();
  const [loading, setLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2018 + 1 }, (_, i) => {
    const year = currentYear - i;
    return { id: year, name: year.toString() };
  });
  const months = [
    { id: 1, name: "Jan" },
    { id: 2, name: "Feb" },
    { id: 3, name: "Mar" },
    { id: 4, name: "Apr" },
    { id: 5, name: "May" },
    { id: 6, name: "Jun" },
    { id: 7, name: "Jul" },
    { id: 8, name: "Aug" },
    { id: 9, name: "Sep" },
    { id: 10, name: "Oct" },
    { id: 11, name: "Nov" },
    { id: 12, name: "Dec" },
  ];

  const getStartAndEndOfWeek = () => {
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Adjust to the beginning of the week
    const startOfWeek = new Date(now.setDate(diff));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // End of the week is 6 days later

    return {
      startOfWeek: formatDate(startOfWeek),
      endOfWeek: formatDate(endOfWeek),
    };
  };
  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };

  const getStartAndEndOfMonth = () => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    return {
      startOfMonth: formatDate(startOfMonth),
      endOfMonth: formatDate(endOfMonth),
    };
  };

  const getStartAndEndOfYear = () => {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const endOfYear = new Date(now.getFullYear(), 11, 31);

    return {
      startOfYear: formatDate(startOfYear),
      endOfYear: formatDate(endOfYear),
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Modify the API call with parameters
        const res = await api.get(
          params.ApiKey ? params.ApiKey : AdminApi.DASH_ENROLLMENTS,
          {
            params: {
              filters: {
                ...filters,
                ...params.filterData,
              },
            },
          },
        );

        setEnrollData(res.data.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters, params.filterData]);

  const handleCurrentYear = () => {
    setFilters({
      year: new Date().getFullYear(),
    });
    setActiveButton("currentYear");
  };
  const handleCurrentMonth = () => {
    const { startOfMonth, endOfMonth } = getStartAndEndOfMonth();

    setFilters({
      from_date: startOfMonth,
      to_date: endOfMonth,
    });
    setActiveButton("currentMonth");
  };
  const handleThisWeek = () => {
    const { startOfWeek, endOfWeek } = getStartAndEndOfWeek();

    setFilters({
      from_date: startOfWeek,
      to_date: endOfWeek,
    });
    setActiveButton("thisWeek");
  };
  const handleSoFar = () => {
    setFilters();
    setActiveButton("soFar");
  };
  const handleEnrollmentsClick = () => {
    // Use the enrollData state variable instead of params.filterData
    if (!enrollData || !enrollData.enrollment_list) {
      console.log("No enrollment data available to download");
      return;
    }

    // CSV header
    let csvContent =
      "ID,First Name,Last Name,Email,Registration Date,Cohort,Section,Location\n";

    // Add data rows
    enrollData.enrollment_list.forEach((enrollment) => {
      console.log("enrollment", enrollment);
      csvContent += `${escapeCSV(enrollment.id)},${escapeCSV(
        enrollment.first_name,
      )},${escapeCSV(enrollment.last_name)},${escapeCSV(
        enrollment.email,
      )},${escapeCSV(
        enrollment.registration_date
          ? moment(enrollment.registration_date).format("DD-MM-YYYY")
          : "",
      )},${escapeCSV(enrollment.cohort)},${escapeCSV(
        enrollment.section,
      )},${escapeCSV(enrollment.location_name)}\n`;
    });

    downloadCSV(csvContent, "enrollments.csv");
  };
  // Helper function to escape CSV values
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return "";

    // Convert to string and check if we need to wrap in quotes
    const stringValue = String(value);
    if (
      stringValue.includes(",") ||
      stringValue.includes('"') ||
      stringValue.includes("\n")
    ) {
      // Escape quotes by doubling them and wrap in quotes
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  // Common download function
  const downloadCSV = (csvContent, fileName) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {loading ? (
        <DataLoader />
      ) : (
        <>
          <Box marginTop={4}>
            {params.filter && (
              <Grid
                item
                xs={12}
                marginBottom={2}
                className={styles.totalJobsContainer_}
              >
                <Button
                  className={`${styles.btns} ${
                    activeButton === "soFar" ? styles.active : ""
                  }`}
                  onClick={handleSoFar}
                >
                  So Far
                </Button>
                <Button
                  className={`${styles.btns} ${
                    activeButton === "thisWeek" ? styles.active : ""
                  }`}
                  onClick={handleThisWeek}
                >
                  This week
                </Button>
                <Button
                  className={`${styles.btns} ${
                    activeButton === "currentMonth" ? styles.active : ""
                  }`}
                  onClick={handleCurrentMonth}
                >
                  This Month
                </Button>
                <Button
                  className={`${styles.btns} ${
                    activeButton === "currentYear" ? styles.active : ""
                  }`}
                  onClick={handleCurrentYear}
                >
                  This Year
                </Button>
              </Grid>
            )}
            <Grid
              container
              marginTop={2}
              className={styles.totalJobsContainer_wrap}
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    px: "15px",
                    pb: "10px",
                    width: "100%",
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  {!params.location && (
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <SelectOptionsApi
                        apiEndpoint={AdminApi.LOCATION_PAGINATE}
                        formData={filters}
                        onUpdate={handleUpdate}
                        labelKey="name"
                        name="location"
                        valueKey="id"
                        errorText=""
                        paramId={""}
                        defaultText="Select location"
                      />
                    </Box>
                  )}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <FilterMultiSelect
                      options={years}
                      formData={
                        activeButton === "currentYear"
                          ? { ...filters, year: undefined }
                          : filters
                      }
                      onUpdate={handleUpdate}
                      labelKey="name"
                      name="year"
                      valueKey="id"
                      errorText=""
                      defaultText="Select Year"
                    />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <FilterMultiSelect
                      options={months}
                      formData={filters}
                      onUpdate={handleUpdate}
                      labelKey="name"
                      name="month"
                      valueKey="id"
                      errorText=""
                      defaultText="Select Month"
                      disabled={
                        activeButton === "currentYear" ||
                        !filters?.year ||
                        (Array.isArray(filters.year) &&
                          filters.year.length === 0)
                      }
                    />
                  </Box>
                </Box>
                <Box
                  className={styles.totalJobsContainer}
                  onClick={handleEnrollmentsClick}
                  style={{ cursor: "pointer" }}
                  title="Click to download enrollment data as CSV"
                >
                  <Box className={styles.left_box}>
                    <Typography variant="h6">
                      Enrollments {filterActive ? "**" : ""}
                    </Typography>
                    <Typography variant="h4">
                      {enrollData && enrollData.enrollments_count}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box className={styles.imageContainer}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="35"
                        viewBox="0 0 31 35"
                        fill="none"
                      >
                        <path
                          d="M19.9141 8.3808C21.4399 9.3375 22.5098 10.9564 22.7046 12.8356C23.3269 13.1264 24.0176 13.2936 24.7498 13.2936C27.423 13.2936 29.5896 11.1269 29.5896 8.4541C29.5896 5.7809 27.423 3.6143 24.7498 3.6143C22.1021 3.6151 19.9544 5.7431 19.9141 8.3808ZM16.7434 18.2903C19.4166 18.2903 21.5832 16.1233 21.5832 13.4505C21.5832 10.7777 19.4162 8.611 16.7434 8.611C14.0706 8.611 11.9027 10.7781 11.9027 13.4509C11.9027 16.1237 14.0706 18.2903 16.7434 18.2903ZM18.7964 18.6202H14.6896C11.2726 18.6202 8.4928 21.4005 8.4928 24.8174V29.8397L8.5055 29.9183L8.8515 30.0267C12.1124 31.0455 14.9453 31.3853 17.2771 31.3853C21.8316 31.3853 24.4714 30.0868 24.6341 30.004L24.9574 29.8405H24.992V24.8174C24.9932 21.4005 22.2133 18.6202 18.7964 18.6202ZM26.8036 13.6239H22.7285C22.6845 15.2543 21.9885 16.7225 20.8876 17.7784C23.9249 18.6815 26.1471 21.4981 26.1471 24.8248V26.3725C30.1707 26.225 32.4893 25.0847 32.6421 25.0081L32.9654 24.8442H33V19.8203C33 16.4037 30.2201 13.6239 26.8036 13.6239ZM8.251 13.2944C9.1978 13.2944 10.0787 13.018 10.825 12.5473C11.0622 11.0001 11.8916 9.648 13.0765 8.7272C13.0814 8.6366 13.09 8.5468 13.09 8.4554C13.09 5.7822 10.923 3.6155 8.251 3.6155C5.5774 3.6155 3.4112 5.7822 3.4112 8.4554C3.4112 11.1273 5.5774 13.2944 8.251 13.2944ZM12.5975 17.7784C11.502 16.7278 10.8085 15.2675 10.7578 13.6469C10.6067 13.6358 10.4572 13.6239 10.3032 13.6239H6.1968C2.7799 13.6239 0 16.4037 0 19.8203V24.8434L0.0128 24.9208L0.3587 25.0299C2.9747 25.8466 5.3093 26.223 7.3372 26.3416V24.8248C7.338 21.4981 9.5594 18.6824 12.5975 17.7784Z"
                          fill="white"
                        />
                      </svg>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </>
  );
};
